import ko from 'knockout';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export default class ViewModel {
  constructor() {
    this.disableAction = ko.observable(false);
    this.showProgress = ko.observable(false);
    this.totalRowCount = ko.observable(0);
    this.successRowCount = ko.observable(0);
    this.errorRowCount = ko.observable(0);
    this.percentage = ko.computed(() => {
      let percent = 0;

      if (this.totalRowCount() > 0) {
        percent = ((this.successRowCount() + this.errorRowCount()) / this.totalRowCount()) * 100;
        percent = percent.toFixed(2);
      }
      return percent;
    });
    this.percentageWidth = ko.computed(() => `${this.percentage()}%`);
    this.percentageText = ko.computed(() =>
      i18n.getString('Formatter_Percentage_New', {
        percentage: this.percentage(),
      }));
  }
}
